import { URLPattern } from "./dist/urlpattern.js";

export { URLPattern };

if (!globalThis.URLPattern) {
  globalThis.URLPattern = URLPattern;
}
